// ./components/ui/usePreventTopScroll.js

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function usePreventTopScroll ()  {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== '/') {
      window.scrollTo(0, 1);

      const preventScrollToTop = () => {
        if (window.scrollY === 0) {
          window.scrollTo(0, 1);
        }
      };

      window.addEventListener('scroll', preventScrollToTop);

      return () => {
        window.removeEventListener('scroll', preventScrollToTop);
      };
    }
  }, [location]);
};


